// import JSZip = require('../lib/jszip.min.js')
import AppData from '../pacakge/public/const/app_data'
import Utility from '../utility/utility'
import OssManager from './oss_manager'
import LoaclStorage from './local_storage'
import ModelData from '../pacakge/public/model_data'
import AppController from '../sdk/app_controller'
import GameUtil from '../utility/game_util'

//--最多保留天数+1
const const_maximum_period_of_days = 5
//--最多保留的大小
const const_max_files_size = 0.001 * 1024 * 1024
//清理日志的周期
const const_clear_period_of_times = 1 * 24 * 3600
//开启自动上传日志的周期，60分钟上传的间隔
const const_auto_upload_log_archive_period_of_times = 600

let auto_upload_log_archive_time: number = 0
let start_auto_upload_log_archive_time: number = 0

export default class LogManager {
    protected static m_instance: LogManager = null
    static get instance() {
        if (!LogManager.m_instance) {
            LogManager.m_instance = new LogManager()
        }
        return LogManager.m_instance;
    }

    protected m_curDateTimeString: string = null
    protected m_curDir: string = null
    protected m_logFileDirPath: string = null
    protected m_curFilePath: string = null
    protected m_curFileSize: number = 0
    protected m_curLogText: string = ''
    protected m_uid: number = 0
    protected m_lastClearLogsTime: number = 0
    protected m_isUploadingArchive: boolean = false
    protected m_startAutoUploadArchiveTime: number = 0
    protected m_autoUploadLogArchiveTime: number = 0

    private lastUploadTime = 0

    public uploadLogFileTempToken;
    public uploadLogFileTempUid;

    constructor() {
        if (!cc.sys.isNative) {
            return;
        }
        this.m_logFileDirPath = jsb.fileUtils.getWritablePath() + 'log'
        if (!this.is_dir_exist(this.m_logFileDirPath)) {
            this.createDirectory(this.m_logFileDirPath)
        }
        this.m_uid = LoaclStorage.getNumber("LastLoginID", null)
    }

    public init() {
        this.clear_expired_log()
    }


    private formatDate(date: Date, fmt) {
        var o = {
            "M+": date.getMonth() + 1,                 //月份   
            "d+": date.getDate(),                    //日   
            "h+": date.getHours(),                   //小时   
            "m+": date.getMinutes(),                 //分   
            "s+": date.getSeconds(),                 //秒   
            // "q+": Math.floor((date.getMonth() + 3) / 3), //季度   
            // "S": date.getMilliseconds()             //毫秒   
        };
        if (/(y+)/.test(fmt))
            fmt = fmt.replace(RegExp.$1, (date.getFullYear() + "").substr(4 - RegExp.$1.length));
        for (var k in o)
            if (new RegExp("(" + k + ")").test(fmt))
                fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
        return fmt;
    }

    private get_format_timestamp(forFileName?, onlyDay?, timestamp?) {
        timestamp = timestamp || Date.now() * 0.001
        let date = new Date(timestamp * 1000)
        if (forFileName) {
            return `${this.formatDate(date, 'yyyy_MM_dd_hh_mm_ss')}`
        }
        if (onlyDay) {
            return `${this.formatDate(date, 'yyyy_MM_dd')}`
        }
        return `【${this.formatDate(date, 'yyyy-MM-dd hh:mm:ss')}】`
    }


    private format_log(logStr: string, stackTrace?) {
        let text = this.get_format_timestamp() + logStr
        this.append_to_log_file(text)
    }

    private clear_logs() {
        let self = this
        let now = Date.now() * 0.001
        if (now - this.m_lastClearLogsTime < const_clear_period_of_times) {
            return
        }
        this.m_lastClearLogsTime = now
        setTimeout(function () {
            self.clear_expire_logs()
        })
    }

    private clear_expire_logs() {
        if (!this.is_dir_exist(this.m_logFileDirPath)) {
            return
        }
        let filePaths = this.get_all_files_in_dir(this.m_logFileDirPath)
        if (filePaths.length == 0) {
            return
        }
        let stayList = []
        let now = Date.now() * 0.001
        for (let index = const_maximum_period_of_days - 1; index >= 0; index--) {
            let timestamp = now - index * 3600 * 24
            let dateTimeString = this.get_format_timestamp(false, true, timestamp)
            stayList.push({ dateTimeString: dateTimeString })
        }
        let totalSize = 0
        let stayFileList = []
        let needClearFiles = []
        let len = filePaths.length
        for (let i = 0; i < len; i++) {
            let isMatch = false
            let path = filePaths[i]
            for (let j = 0; j < stayList.length; j++) {
                let stay = stayList[j]
                let matchIndex = path.indexOf(stay.dateTimeString)
                if (matchIndex >= 0) {
                    isMatch = true
                    let fileSize = this.get_file_size(path)
                    totalSize += fileSize
                    let fileName = this.get_file_name_from_path(path, true)
                    let timestamp = Number(fileName.replace(/_/g, ''))
                    stayFileList.push({ fileSize: fileSize, path: path, timestamp: timestamp })
                    break
                }
            }
            if (!isMatch) {
                needClearFiles.push(path)
            }
        }
        stayFileList.sort(function (a, b) {
            return a.timestamp - b.timestamp
        })
        if (totalSize > const_max_files_size) {
            for (let i = 0; i < stayFileList.length; i++) {
                let stayFileData = stayFileList[i]
                if (totalSize > const_max_files_size) {
                    totalSize -= stayFileData.fileSize
                    needClearFiles.push(stayFileData.path)
                }
            }
        }
        for (let i = 0; i < needClearFiles.length; i++) {
            if (this.is_file_exist(needClearFiles[i])) {
                this.delete_file(needClearFiles[i])
            }
        }
    }

    private tell_api_server(url: string, onFinish: Function) {
        let requestData: IHttpRequestData = {
            baseUrl: AppData.httpApiMobileUrl + "commons/uploadLog?",  ///commons/uploadLog
            params: {
                userId: ModelData.instance.roleData.id,
                url: url
            },
  
        }
        if (this.uploadLogFileTempToken != null) {
            requestData.params.userId = this.m_uid
            requestData.token = this.uploadLogFileTempToken
        }
        GameUtil.http_get(requestData, () => {
            onFinish && onFinish()
        })
    }

    private compress_file(dirPath: string, zipPath: string, onFinish: Function) {
        let self = this
        // let zip = new JSZip()
        // let filePaths = this.get_all_files_in_dir(dirPath)
        // for (let index = 0; index < filePaths.length; index++) {
        //     const filePath = filePaths[index];
        //     let text = this.read_file(filePath)
        //     let relativeFilePath = this.get_relative_path(filePath, this.m_logFileDirPath)
        //     zip.file(relativeFilePath, text, { createFolders: true })
        // }
        // zip.generateAsync({ type: "uint8array" }).then(function (content) {
        //     self.write_bytes_file(zipPath, content)
        //     for (let index = 0; index < filePaths.length; index++) {
        //         const element = filePaths[index];
        //         self.delete_file(element)
        //     }
        //     onFinish && onFinish(zipPath, content)
        // })
    }


    private upload_files(key: string, filePath: string, onFinish: Function, onError: Function, upLoadTimes: number) {
        OssManager.instance.upload_log(key, this.read_file_data(filePath), onFinish, onError, 5)
    }

    public auto_upload_log_archive(uploadLogStatus, onFinish?) {
        if (!cc.sys.isNative) {
            return;
        }
        if (uploadLogStatus != null && uploadLogStatus == (LoaclStorage.getNumber('auto_upload_log_status') || 0)) {
            return
        }
        let needUploadLog = false
        let now = Date.now()
        if (now - auto_upload_log_archive_time > const_auto_upload_log_archive_period_of_times * 1000 && (!this.m_isUploadingArchive)) {
            needUploadLog = true
        } else if (this.m_isUploadingArchive && now - start_auto_upload_log_archive_time > 60 * 1000) {//--如果在上传的过程中一分钟内没上传成功再上传一次
            needUploadLog = true
        }
        if (needUploadLog) {
            this.upload_log_archive(function () {
                if (uploadLogStatus != null) {
                    LoaclStorage.setNumber('auto_upload_log_status', uploadLogStatus)
                }
                onFinish && onFinish()
            })
        }
    }

    public upload_log_archive(onFinish?: Function, onError?: Function) {
        let self = this
        if (!cc.sys.isNative) {
            return;
        }
        if (!this.is_dir_exist(this.m_logFileDirPath)) {
            onError && onError('no local log file')
            return
        }
        self.m_isUploadingArchive = true
        self.m_startAutoUploadArchiveTime = Date.now() * 0.001
        let zipPath = `${this.m_logFileDirPath}/log.zip`
        let onFinishCompress = function (zipPath) {
            let key = `${self.m_uid}-${self.get_format_timestamp(true)}-${Utility.randomToInt(0, 99999)}.zip`
            self.upload_files(key, zipPath, function (url) {
                self.tell_api_server(url, function (err) {
                    self.m_isUploadingArchive = false
                    self.m_autoUploadLogArchiveTime = Date.now() * 0.001
                    self.delete_file(zipPath)
                    if (err) {
                        onError && onError()
                    } else {
                        onFinish && onFinish()
                    }
                })
            }, function () {
                self.m_isUploadingArchive = false
                self.delete_file(zipPath)
                onError && onError()
            }, 5)
        }
        if (!this.is_file_exist(zipPath)) {
            self.compress_file(self.m_logFileDirPath, zipPath, onFinishCompress)
        } else {
            onFinishCompress(zipPath)
        }
    }

    private is_match(filePath: string, filters: string[]): boolean {
        for (let index = 0; index < filters.length; index++) {
            const element = filters[index];
            if (filePath.indexOf(element) < 0) {
                return false
            }
        }
        return true
    }

    private get_relative_path(path: string, rootPath: string): string {
        return path.replace(rootPath + '/', '')
    }

    private get_file_name_from_path(path: string, withoutExtension?: boolean): string {
        let index = path.lastIndexOf('/')
        let fileName = path.substring(index + 1)
        if (withoutExtension) {
            index = fileName.lastIndexOf('.')
            if (index > 0) {
                fileName = fileName.substring(0, index)
            }
        }
        return fileName
    }

    private get_dir_path_from_path(path: string): string {
        let index = path.lastIndexOf('/')
        return path.substring(0, index)
    }

    private createDirectory(dirPath: string) {
        return jsb.fileUtils.createDirectory(dirPath)
    }

    private is_dir_exist(dirPath: string) {
        return jsb.fileUtils.isDirectoryExist(dirPath)
    }

    private is_file_exist(filePath: string) {
        let reuslt = jsb.fileUtils.isFileExist(filePath)
        return reuslt
    }

    private get_file_size(filePath: string): number {
        if (!this.is_file_exist(filePath)) {
            return 0
        }
        return jsb.fileUtils.getFileSize(filePath)
    }

    private delete_dir(path: string) {
        jsb.fileUtils.removeDirectory(path)
    }

    private delete_file(path: string) {
        jsb.fileUtils.removeFile(path)
    }

    private write_file(path: string, text: string) {
        let dirPath = this.get_dir_path_from_path(path)
        if (!this.is_dir_exist(dirPath)) {
            this.createDirectory(dirPath)
        }
        let result = jsb.fileUtils.writeStringToFile(text, path)
        return result
    }


    private write_bytes_file(path: string, bytes: ArrayBuffer) {
        let dirPath = this.get_dir_path_from_path(path)
        if (!this.is_dir_exist(dirPath)) {
            this.createDirectory(dirPath)
        }
        let result = jsb.fileUtils.writeDataToFile(bytes, path)
        return result
    }

    private read_file(path: string): string {
        let text = jsb.fileUtils.getStringFromFile(path)
        return text
    }

    private read_file_data(path: string): Uint8Array {
        let bytes = jsb.fileUtils.getDataFromFile(path)
        return bytes
    }

    private get_dir_path(uid?: number): string {
        // uid = uid || this.m_uid
        // let parentDirName = AppData.gameName || 'main'
        return `${this.m_logFileDirPath}/` //${parentDirName}/${uid}
    }

    private gen_file_path_data(dir, dateTimeString, newFile): { filePath: string, isNew: boolean } {
        let filePath = `${dir}/${this.get_format_timestamp(true)}.log`
        if (newFile) {
            return { filePath: filePath, isNew: true }
        }
        let matchFiles = this.match_file_path(this.m_logFileDirPath, [dir, dateTimeString])
        if (matchFiles && matchFiles.length > 0) {
            matchFiles.sort(function (a, b) { return b.localeCompare(a) })
            filePath = matchFiles[0]
            return { filePath: filePath, isNew: false }
        }
        return { filePath: filePath, isNew: true }
    }


    private match_file_path(dirPath: string, filters: string[]): string[] {
        let results = []
        if (!this.is_dir_exist(dirPath)) {
            return results
        }
        let files = this.get_all_files_in_dir(dirPath)
        if (files.length > 0) {
            for (let index = 0; index < files.length; index++) {
                const filePath = files[index];
                let isMatch = this.is_match(filePath, filters)
                if (isMatch) {
                    results.push(filePath)
                }
            }
        }
        return results
    }

    private get_all_files_in_dir(dirPath: string, recursion?: boolean): string[] {
        let list = jsb.fileUtils.listFiles(dirPath)
        let files = []
        for (let index = 0; index < list.length; index++) {
            const element = list[index];
            if (element.lastIndexOf('/') != element.length - 1) {
                files.push(element)
            } else {
                if (element.lastIndexOf('./') == element.length - 2 || element.lastIndexOf('../') == element.length - 3) {

                } else {
                    files = files.concat(this.get_all_files_in_dir(element))
                }
            }
        }
        return files
    }


    private append_to_log_file(appendStr) {
        let dir = this.get_dir_path()
        let filePath = this.get_file_path(dir)
        this.apend_to_file(filePath, appendStr)
    }
    private get_file_path(dir) {
        let dayTimeStr = `${this.formatDate(new Date(Date.now()), 'yyyy_MM_dd')}`
        let houerTimeStr = `${this.formatDate(new Date(Date.now()), 'yyyy_MM_dd_hh')}`
        let filePath = `${dir}/${dayTimeStr}/${houerTimeStr}.log`
        return filePath
    }
    private apend_to_file(path: string, text: string) {
        let dirPath = this.get_dir_path_from_path(path)
        if (!this.is_dir_exist(dirPath)) {
            this.createDirectory(dirPath)
        }
        if (!this.is_file_exist(path)) {
            let text = ""
            let deviceInfo = AppController.instance.deviceInfo()
            text += `device info : ${JSON.stringify(deviceInfo)} \n`
            jsb.fileUtils.appendStringToFile(text, path)
        }
        let result = jsb.fileUtils.appendStringToFile(text, path)
        return result
    }
    private lengthInUtf8Bytes(str) {
        let m = encodeURIComponent(str).match(/%[89ABab]/g);
        return str.length + (m ? m.length : 0);
    }

    setUid(uid) {
        this.m_uid = uid
        this.uploadLogFileTempToken = null
        this.uploadLogFileTempUid = null
    }

    log(msg: string | any, showCCLog?: boolean) {
        if (msg == null) return

        showCCLog && cc.log(msg)
        if (!cc.sys.isNative) {
            return;
        }
        if (CC_PREVIEW) {
            return
        }
        if (!Utility.version_judge(AppData.appVersion, "1.2.0")) {
            return
        }
        try {
            this.append_to_log_file(`【${Utility.dateFormat('yy-MM-dd hh:mm:ss')}】${msg}\n`)
        } catch (error) {
            cc.error('LogManager error:', error)
        }
    }


    clear_expired_log(day?: number) {
        if (!cc.sys.isNative) {
            return;
        }
        if (!Utility.version_judge(AppData.appVersion, "1.2.0")) {
            return
        }
        if (!this.is_dir_exist(this.m_logFileDirPath)) {
            return
        }
        let list = jsb.fileUtils.listFiles(this.m_logFileDirPath)
        if (list.length < 3) {
            return
        }
        let data = new Date(Date.now())
        let curYear = data.getFullYear()
        let curMonth = data.getMonth() + 1
        let curDay = data.getDate()
        cc.log("clear_expired_log,current data:", `${curYear}-${curMonth}-${curDay}`, list.length, day)
        if (day == null) {
            day = const_maximum_period_of_days
        }
        for (let i = 0; i < list.length; i++) {
            let p = list[i]
            let pl = p.split("/")
            let n = p.substr(p.length - 1, 1) == "/" ? pl[pl.length - 2] : pl[pl.length - 1]
            let nl = n.split("_")
            if (nl[0] != "." && nl[0] != "..") {
                let fy = parseInt(nl[0])
                let fm = parseInt(nl[1])
                let fd = parseInt(nl[2])
                cc.log("clear_expired_log,log data:", p, `${fy}-${fm}-${fd}`, i, day)
                if (curYear > fy || curMonth > fm + 1 || (curMonth > fm && new Date(fy, fm, 0).getDate() + curDay - fd >= day) || curDay - fd >= day) {
                    cc.log("clear_expired_log,clear log:", p, `${fy}-${fm}-${fd}`, i, day, p.indexOf("."))
                    if (p.indexOf(".") > -1) {
                        jsb.fileUtils.removeFile(p)
                    } else {
                        jsb.fileUtils.removeDirectory(p)
                    }
                } else {
                    if (curDay != fd) {
                        let c = this.compress_log_file(p, this.m_logFileDirPath + "/", `${nl[0]}_${nl[1]}_${nl[2]}_log.zip`)
                        if (c) {
                            cc.log("clear_expired_log,clear log2:", p, `${fy}-${fm}-${fd}`, i, day)
                            jsb.fileUtils.removeDirectory(p)
                        }
                    }
                }
            }
        }
    }

    compress_log_file(sourcePath, zipPath, zipName) {
        if (!cc.sys.isNative) {
            return null
        }
        if (!Utility.version_judge(AppData.appVersion, "1.2.0")) {
            return
        }
        if (!this.is_dir_exist(sourcePath)) {
            return null
        }
        let zipFilePath = zipPath + zipName
        if (this.is_file_exist(zipFilePath)) {
            jsb.fileUtils.removeFile(zipFilePath)
        }
        let compress = AppController.instance.createZipFile(sourcePath, zipPath, zipName)
        cc.log("compress_log_file,compress result:", compress, zipFilePath, this.is_file_exist(zipFilePath))
        if (compress == "success") {
            return zipFilePath
        } else {
            return null
        }
    }
    upload_log_file(clientLogInfo?, callback?) {
        let self = this
        if (!cc.sys.isNative) {
            return;
        }
        if (!Utility.version_judge(AppData.appVersion, "1.2.0")) {
            return
        }

        

        let compressPath = this.compress_log_file(this.m_logFileDirPath, jsb.fileUtils.getWritablePath(), "log.zip")
        if (compressPath != null) {
            let key = `${this.m_uid}/log-${this.get_format_timestamp(true)}-${Utility.randomToInt(0, 99999)}.zipp`
            this.upload_files(key, compressPath, function (url) {
                cc.log("log upload success, url:", url)
                self.tell_api_server(url, function (err) {
                    clientLogInfo && LoaclStorage.setString("ClientLogInfo", clientLogInfo)
                    self.m_isUploadingArchive = false
                    self.m_autoUploadLogArchiveTime = Date.now() * 0.001
                    self.delete_file(compressPath)
                    self.clear_expired_log(0)
                    callback && callback()
                })
            }, function () {
                cc.log("log upload success, fail")
            }, 3)
        }
    }

    setTmpUidAndToken(uid, token) {
        this.m_uid = uid
        this.uploadLogFileTempUid = uid
        this.uploadLogFileTempToken = token
    }
    

    needUploadLogFile(clientLogInfo) {
        if (!cc.sys.isNative) {
            return;
        }
        let localInfo = LoaclStorage.getString("ClientLogInfo", "")
        if (clientLogInfo != null && clientLogInfo != "" && clientLogInfo != undefined && clientLogInfo != localInfo) {
            cc.log("log upload open 日志上传开启，开始上传日志")
            LogManager.instance.upload_log_file(clientLogInfo)
        }
    }

    uploadLogFile(callback) {
        if (!cc.sys.isNative) {
            return;
        }
        LogManager.instance.upload_log_file(null, callback)
    }

}
